<template>
  <v-row class="m-0">
    <v-col cols="2" class='p-0' v-if="image">
      <v-img :src='image' class="image-preview"></v-img>
    </v-col>
    <v-col class='p-0 align-self-center'>
      <v-file-input v-model="file"
                    accept="image/*"
                    :label="ressource.label"
                    @change="createImage">
      </v-file-input>
    </v-col>
  </v-row>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';
  import ImageBase from '@/framework/base/components/ImageBase';

  export default defineComponent({
    extends: ImageBase,
    components: { },
    computed: {
      ressource () { return RessourceGenControl(GenControl.SALARIE_AVATAR); },
    }
  })
</script>
